import { render } from "./DashboardRecentActivityCard.vue?vue&type=template&id=fb81b350"
import script from "./DashboardRecentActivityCard.vue?vue&type=script&lang=js"
export * from "./DashboardRecentActivityCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__